module.exports = __webpack_public_path__ + "static/kuma-fit-story-thumbnail-a7190183c745bc6c4a97151ab1bef7ab.png";